import React from 'react';

interface EmailMaskProps {
  email: string;
  visibleUsernameLength?: number;
  visibleDomainLength?: number;
}

const EmailMask: React.FC<EmailMaskProps> = ({
  email = '',
  visibleUsernameLength = 3,
  visibleDomainLength = 2,
}) => {

  const [username, domain] = email.split('@');
  const lastDotIndex = domain.lastIndexOf('.');

  if (lastDotIndex === -1) {
    return <span>Invalid domain</span>;
  }

  const domainName = domain.slice(0, lastDotIndex);
  const topLevelDomain = domain.slice(lastDotIndex + 1);

  const safeSlice = (str: string, visibleLength: number): string => {
    if (visibleLength >= str.length) return str;
    const visiblePart = str.slice(0, visibleLength);
    const maskedPart = '*'.repeat(str.length - visibleLength);
    return visiblePart + maskedPart;
  };

  const maskedUsername = safeSlice(username, visibleUsernameLength);
  const maskedDomainName = safeSlice(domainName, visibleDomainLength);
  const maskedDomain = `${maskedDomainName}.${topLevelDomain}`;
  const maskedEmail = `${maskedUsername}@${maskedDomain}`;

  return <>{maskedEmail}</>;
};

export default EmailMask;